import { httpClient } from "../../../shared/api/httpClient";
import type { PaginatedResponse } from "../../../shared/api/pagination";
import type {
  CreateSaleRequest,
  GetSalesParams,
  SaleListResult,
  SaleResponse,
  UpdateSaleRequest,
} from "../model/types";

export const getSales = async (
  params: GetSalesParams,
): Promise<SaleListResult> => {
  const response = await httpClient.get<PaginatedResponse<SaleResponse>>(
    "/sales",
    { params },
  );
  return {
    items: response.data.items,
    total: response.data.pagination.total,
    page: response.data.pagination.page,
    page_size: response.data.pagination.page_size,
  };
};

export const getSale = async (lineId: string): Promise<SaleResponse> => {
  const response = await httpClient.get<SaleResponse>(
    `/sales/${encodeURIComponent(lineId)}`,
  );
  return response.data;
};

export const createSale = async (
  payload: CreateSaleRequest,
): Promise<SaleResponse> => {
  const response = await httpClient.post<SaleResponse>("/sales", payload);
  return response.data;
};

export const updateSale = async (
  lineId: string,
  payload: UpdateSaleRequest,
): Promise<SaleResponse> => {
  const response = await httpClient.put<SaleResponse>(
    `/sales/${encodeURIComponent(lineId)}`,
    payload,
  );
  return response.data;
};

export const deleteSale = async (lineId: string): Promise<void> => {
  await httpClient.delete(`/sales/${encodeURIComponent(lineId)}`);
};
